<section class="mainTopBanner toolsTopBanner section-pd">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="topBannerWrapper align-items-center">
                    <div class="top-banner-left text-center">
                        <h1 class="singleTag">免費線上拼寫檢查工具</h1>
                        <p class="mb-0">使用Trinka的免費拼寫檢查工具即時糾正拼寫錯誤。</p>
                        <p>覺得分辨單詞的正確拼寫很困難？Trinka AI能夠根據您的學科領域識別和建議正確的單詞拼寫，進一步提高您的寫作。Trinka更重要的是能夠根據句子的上下文建議拼寫更正，始終為您提供最佳建議！</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-english-grammar-checker></app-english-grammar-checker>
            </div>
        </div>
    </div>
    <span class="shape shape-1"></span>
    <span class="shape shape-2"></span>
</section>

<app-browser-detection [title]="'隨時隨地進行高級上下文拼寫檢查！'"></app-browser-detection>

<section class="the_best_grammer_sections section-pd">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-sm-12">
                <div class="trinka-title mb-0">
                    <h2>最佳免費線上拼寫檢查工具</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p>Trinka的拼寫檢查工具可以識別您寫作中最複雜的拼寫錯誤並提供建議。</p>
                    <p>rinka能幫助您以高精度修訂最常見和最嚴重的文法和拼寫錯誤，從而提高您的寫作技巧和整體文檔品質。</p>
                    <div class="most_suited_point">
                        <ul>
                            <li>
                                <span><img src="assets/images/Circle_checks.png" width="30" height="30" alt="checkbox" /></span>
                                高級上下文拼寫檢查
                            </li>
                            <li>
                                <span><img src="assets/images/Circle_checks.png" width="30" height="30" alt="checkbox" /></span>
                                高級文法檢查
                            </li>
                            <li>
                                <span><img src="assets/images/Circle_checks.png" width="30" height="30" alt="checkbox" /></span>
                                免費使用
                            </li>
                            <li>
                                <span><img src="assets/images/Circle_checks.png" width="30" height="30" alt="checkbox" /></span>
                                高質量的數據安全
                            </li>
                        </ul>
                    </div>
                    <p>Trinka的線上拼寫檢查工具可檢測拼寫錯誤，並且提供建議和解釋讓您更容易理解。</p>
                    <p>註冊以免費解鎖更多功能！</p>
                    <div class="btn-group">
                        <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank" class="filled-btn">開始使用</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">誰可以使用Trinka的拼寫檢查工具？</h3>
                    <p class="text-white">
                        Trinka適合任何希望提高英語寫作技能的用戶，它的免費拼寫檢查工具受到學者、文案、行銷人員、內容作者、產品團隊、博主、自出版作者等作者的信任。
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="the_best_grammer_sections section-pd">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinka拼寫檢查工具的主要功能</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>高級拼寫檢查</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka的免費拼寫檢查工具能夠根據寫作上下文，為您的主題選擇正確的單詞。為您避免尷尬的拼寫錯誤！</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Technical word choice</h4> -->
                            <p>The <span class="wrongText">Bonferoni</span> <span class="rightText"> Bonferroni</span> test was used to check for statistical significance.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>適用於所有主題</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>
                                您可以根據主題領域和內容類型自定義Trinka，為您提供最相關的建議。
                            </p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Sensitive language</h4> -->
                            <p>The physical properties of <span class="wrongText">kytoplasm</span> <span class="rightText"> cytoplasm</span> differ considerably from dilute aqueous solutions.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>個人詞典</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>
                                Trinka會記住您添加到詞典中的所有單詞並自動同步到所有平臺，從而隨時隨地為您提供個性化的寫作體驗。
                            </p>
                        </div>
                        <div class="mini_card_grammer add-to-dictionary pc-dictionary min_auto">
                            <app-add-to-dictionary></app-add-to-dictionary>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>全部接受並忽略</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>需要更正整篇論文的拼寫？不想反復看到單詞建議？Trinka讓一切變得簡單！只需單擊一下即可接受或忽略所有此類建議。</p>
                        </div>
                        <div class="mini_card_grammer add-to-dictionary min_auto">
                            <app-add-to-dictionary></app-add-to-dictionary>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-get-trinka></app-get-trinka>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h3>Trinka的免費拼寫檢查工具是如何工作的？</h3>
                    <p>Trinka的拼寫檢查工具不僅可以檢測和糾正拼寫錯誤，還可以檢測文法錯誤。Trinka檢測的拼寫錯誤包括動詞的分詞形式、相近的單詞拼寫以及術語混淆等。</p>
                    <p>使用Trinka糾正所有類型的拼寫錯誤，讓您的寫作傳達清晰而自信的資訊。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <picture>
                        <source srcset="assets/images/tools/WritingMoreEffective.webp" type="image/webp">
                        <img src="assets/images/tools/WritingMoreEffective.png" width="435" height="435"  alt="grammar checker">
                    </picture>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>讓您的寫作避免拼寫錯誤</h3>
                    <p>Trinka的人工智慧拼寫檢查工具採用最新的機器學習（ML）和自然語言（NPL）技術開發而成，可識別最常見和最複雜的單詞拼寫錯誤。</p>
                    <p>想對您的研究論文、學術論文、電子郵件或論文進行拼寫檢查嗎？Trinka將為您保駕護航。除了拼寫檢查，我們還將幫助您輕鬆修訂文法錯誤。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image features-img">
                    <picture>
                        <source srcset="assets/images/tools/LearnGrammarwithTrinka.webp" type="image/webp">
                        <img src="assets/images/tools/LearnGrammarwithTrinka.png" width="435" height="435"  alt="grammar checker">
                    </picture>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="testimonial-section text-center section-pd">
    <app-testimonial></app-testimonial>
</div>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">高級文法和拼寫檢查
                    </h3>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank" class="white-btn" id="grammerSignUpButton">
                            <!-- <i class="fa fa-sign-in"></i> -->
                            <span>免費註冊！</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center">
                    <h2>Trinka的拼寫檢查工具常見問題解答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionGCOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCOneContent" aria-expanded="true" aria-controls="QuestionGCOneContent">什麼是拼寫檢查工具？</a>
                                </div>

                                <div id="QuestionGCOneContent" class="collapse" aria-labelledby="QuestionGCOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>拼寫檢查工具可以幫助識別文檔​​中的拼寫錯誤或印刷錯誤，並根據上下文將其替換為正確的單詞。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCTwoContent" aria-expanded="true" aria-controls="QuestionGCTwoContent">
                                        Trinka如何檢查拼寫錯誤？
                                    </a>
                                </div>

                                <div id="QuestionGCTwoContent" class="collapse" aria-labelledby="QuestionGCTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>只需將您的內容粘貼到編輯器中，然後單擊“檢查我的寫作”，Trinka將突出顯示所有拼寫錯誤並提供最佳的上下文拼寫建議。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionGCThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCThreeContent" aria-expanded="true" aria-controls="QuestionGCThreeContent">
                                        Trinka的拼寫檢查工具是免費使用的嗎？
                                    </a>
                                </div>

                                <div id="QuestionGCThreeContent" class="collapse" aria-labelledby="QuestionGCThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>當然可以，您可以免費使用此頁面上的編輯器來檢查您的內容。如果您想檢查更長的文檔，請在此處<a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank" class=”text-link”>註冊</a>並免費獲得更多功能。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCFourContent" aria-expanded="true" aria-controls="QuestionGCFourContent">
                                        我可以檢查不同網站上的拼寫嗎？
                                    </a>
                                </div>

                                <div id="QuestionGCFourContent" class="collapse" aria-labelledby="QuestionGCFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>可以。您只需在GoogleChrome、火狐Firefox或微軟Edge瀏覽器上安裝我們的<a [routerLink]="['/browser-plugin']" class=”text-link”>插件</a>，就可以在任何網站使用Trinka的拼寫檢查工具。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
